<template>
  <d-alert :theme="warningStyle" show :class="{ 'mr-3 ml-3 w-100': true, 'is-archived': warningData.is_archived }">
    <div class="date">
      <small>
        Valid: <strong>{{ validDate }}</strong>
      </small>
    </div>
    <div class="message">{{ reason }}</div>
    <div :class="{ 'actions': true, 'remove-in-progress': removeInProgress }">
      <a
        href="#"
        class="warning-action is-active"
        @click.prevent="editWarning"
        title="Edit">
        <i class="material-icons">edit</i>
      </a>

      <a
        v-if="warningData.can_be_archived && !warningData.is_archived"
        href="#"
        :class="{ 'warning-action': true, 'is-active': !archiveInProgress }"
        @click.prevent="archiveWarning"
        title="Archive">
        <i class="material-icons">archive</i>
      </a>

      <a
        v-if="warningData.can_be_archived && warningData.is_archived"
        href="#"
        :class="{ 'warning-action': true, 'is-active': !archiveInProgress }"
        @click.prevent="unarchiveWarning"
        title="Unarchive">
        <i class="material-icons">unarchive</i>
      </a>

      <a
        href="#"
        :class="{ 'warning-action': true, 'is-active': !removeInProgress }"
        @click.prevent="removeWarning"
        title="Delete">
        <i class="material-icons">delete</i>
      </a>
    </div>
  </d-alert>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'warnings-list-item',
  props: {
    warningData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  computed: {
    warningStyle () {
      switch (this.warningData.severity_level) {
        case 'LOW': return 'secondary';
        case 'MEDIUM': return 'warning';
        case 'HIGH': return 'danger';
        default: return 'primary';
      }
    },
    validDate () {
      if (this.warningData.valid_to === null) {
        return this.warningData.valid_from + ' - not specified';
      }

      return this.warningData.valid_from + ' - ' + this.warningData.valid_to;
    },
    reason () {
      return this.warningData.message;
    }
  },
  data () {
    return {
      removeInProgress: false,
      archiveInProgress: false
    };
  },
  methods: {
    removeWarning () {
      if (this.removeInProgress) {
        return;
      }

      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/warnings/delete/',
        id: parseInt(this.warningData.id, 10),
        successTitle: 'Warning removed',
        successText: 'The selected warning has been removed',
        confirmTitle: 'Do you really want to remove this warning?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('calendar-warnings-update');
          this.$bus.$emit('warnings-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    editWarning () {
      this.$bus.$emit('show-warning-popup', 'edit', false, false, this.warningData.id);
    },
    archiveWarning () {
      if (this.archiveInProgress) {
        return;
      }

      this.archiveInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/warnings/archive/' + parseInt(this.warningData.id, 10),
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during adding a warning to archive. Please try again.',
        successAction: () => {
          this.archiveInProgress = false;
          this.$bus.$emit('calendar-warnings-update');
          this.$bus.$emit('warnings-list-reload');
        }
      });
    },
    unarchiveWarning () {
      if (this.archiveInProgress) {
        return;
      }

      this.archiveInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/warnings/unarchive/' + parseInt(this.warningData.id, 10),
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during removing a warning from archive. Please try again.',
        successAction: () => {
          this.archiveInProgress = false;
          this.$bus.$emit('calendar-warnings-update');
          this.$bus.$emit('warnings-list-reload');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.warning-action {
  display: inline-block;
}

.is-archived {
  opacity: .5;
}

.alert {
  position: relative;
}

.date {
  width: calc(100% - 100px);
}

.message {
  color: var(--white);
  font-size: 16px;
  width: calc(100% - 100px);
}

.actions {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 110px;

  &.remove-in-progress {
    opacity: .25;
    pointer-events: none;
  }

  a {
    opacity: .5;
    margin: 0 5px;
    pointer-events: none;

    &.is-active {
      opacity: 1;
      pointer-events: auto;

      &:active,
      &:focus,
      &:hover {
        opacity: .85;
      }
    }
  }

  i {
    color: var(--white);
    font-size: 24px;
  }
}
</style>
